<app-uni-page [parent]="this" pageTitle="In-Process: Shipping - {{ title }}" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="my-2 mr-4 flex shrink-0 items-center gap-2.5">
            <button
              pButton
              type="button"
              class="p-button-raised p-button-sm"
              icon="pi pi-plus"
              [disabled]="!(canShip() && currentShipment != null)"
              (click)="setNewShipment()"
            >
              <span>New Shipment</span>
            </button>
            <button
              pButton
              type="button"
              class="p-button-raised p-button-sm"
              icon="pi pi-plus-circle"
              [disabled]="!(canShip() && canAddAllToCurrentShipment())"
              (click)="addAllToCurrentShipment()"
            >
              <span>Consolidate Orders to This Shipment</span>
            </button>
            <p-checkbox
              [(ngModel)]="showCurrentBinsOnly"
              (ngModelChange)="refreshAndUpdate()"
              name="showCurrentBinsOnly"
              inputId="showCurrentBinsOnly"
              [binary]="true"
            ></p-checkbox>
            <label for="showCurrentBinsOnly" class="text-sm">Show Only Bins Shipping Today</label>
        </div>
        <app-ag-grid [gridOptions]="shipBinGridOptions" [rowData]="shipBins" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-panel-title mt-2 mb-1">Pending Invoices</div>
        <app-ag-grid [gridOptions]="invhGridOptions" [rowData]="invoiceHeaders" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
